import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 12.14V11.86C17.9996 11.729 17.9653 11.6003 17.9005 11.4864C17.8357 11.3725 17.7425 11.2773 17.63 11.21L8.84 6.07005C8.14 5.66005 7.86 5.66005 7.62 5.80005L7.37 5.94005C7.25752 6.0073 7.16434 6.10249 7.09951 6.21638C7.03468 6.33027 7.0004 6.459 7 6.59005V17.41C7.00378 17.5377 7.03966 17.6623 7.10433 17.7724C7.169 17.8825 7.26037 17.9746 7.37 18.04L7.62 18.18C7.86 18.32 8.14 18.32 8.68 18L17.63 12.79C17.7425 12.7228 17.8357 12.6276 17.9005 12.5137C17.9653 12.3998 17.9996 12.2711 18 12.14Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgPlay = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgPlay;
